import React from "react";
import { IsAllow } from "../../utils/allowHelper/AllowHelper";
import FormError from "../formError/FormError";
import Can from "components/can/Can";
import { PERMISSION_CODE } from "utils/enum/enums";

const ClientFormBasic = ({
  client,
  onChange,
  allow,
  translate,
  clientId,
  form,
  readOnly,
}) => {
  if (!IsAllow(allow, "customer-01")) return null;

  return (
    <>
      <div>
        <div className="flex items-center gap-4 mb-2">
          <label className="label">{translate("first-name")}</label>
          <div
            className={`flex items-center px-2 py-1 rounded ${
              client.verificationName
                ? "bg-blue-500"
                : "bg-slate-900 dark:bg-slate-300"
            }`}
          >
            <input
              name="verificationName"
              type="checkbox"
              className="mr-2"
              onChange={onChange}
              checked={!!client.verificationName}
              disabled={readOnly}
            />
            <span
              className={`text-xs ${
                client.verificationName
                  ? "text-white"
                  : "text-white dark:text-gray-900 "
              }`}
            >
              {translate("verify-name")}
            </span>
          </div>
        </div>
        <input
          type="text"
          name="firstName"
          value={client.firstName}
          onChange={onChange}
          required
          className="input"
          disabled={readOnly}
        />
        <FormError form={form} name="firstName" />
      </div>

      <div>
        <label className="label">{translate("last-name")}</label>
        <input
          type="text"
          name="lastName"
          value={client.lastName}
          onChange={onChange}
          required
          className="input"
          disabled={readOnly}
        />
        <FormError form={form} name="lastName" />
      </div>

      <div>
        <label className="label">{translate("account-number")}</label>
        <input
          type="text"
          name="accountNumber"
          value={client.accountNumber}
          onChange={onChange}
          disabled={clientId !== "new" || readOnly}
          required
          className="input"
        />

        <FormError form={form} name="accountNumber" />
      </div>
      <Can
        key={"status-customer"}
        permissions={[PERMISSION_CODE.DEACTIVATE_ACTIVATE_CUSTOMERS]}
      >
        <div>
          <label className="label">{translate("status")}</label>
          <select
            name="status"
            value={client.status}
            onChange={onChange}
            className="input"
            disabled={readOnly}
          >
            <option value="active">{translate("active")}</option>
            <option value="inactive">{translate("inactive")}</option>
          </select>
          <FormError form={form} name="status" />
        </div>
      </Can>
    </>
  );
};

export default ClientFormBasic;
